import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {ManagementLevel} from 'shared/models/target-groups/management-level';
import {ManagementLevelRepository} from '../repositories/management-level.repository';

@Injectable()
export class ManagementLevelService {

  constructor(private managementLevelRepository: ManagementLevelRepository) { }

  public getAllManagementLevel(): Observable<Array<ManagementLevel>> {
    return this.managementLevelRepository.getAllManagementLevel();
  }

  public getManagementLevel(id: String): Observable<ManagementLevel> {
    return this.managementLevelRepository.getManagementLevel(id);
  }

  public createManagementLevel(newManagementLevelName: String): Observable<ManagementLevel> {
    const newManagementLevel: ManagementLevel = {
      name: newManagementLevelName,
      level: 1,
    };
    return this.managementLevelRepository.createManagementLevel(newManagementLevel);
  }

  public updateManagementLevel(managementLevel: ManagementLevel): Observable<ManagementLevel> {
    return this.managementLevelRepository.updateManagementLevel(managementLevel);
  }

  public deleteManagementLevel(managementLevel: ManagementLevel): Observable<boolean> {
    return this.managementLevelRepository.deleteManagementLevel(managementLevel);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/management-level/services/management-level.service.ts